import { render, staticRenderFns } from "./maximise-your-zesa-savings.vue?vue&type=template&id=289614ec&scoped=true"
import script from "./maximise-your-zesa-savings.vue?vue&type=script&lang=js"
export * from "./maximise-your-zesa-savings.vue?vue&type=script&lang=js"
import style0 from "./maximise-your-zesa-savings.vue?vue&type=style&index=0&id=289614ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289614ec",
  null
  
)

export default component.exports